<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important">
  {{"header.notify" | translate}}
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
  </h2>
  <mat-dialog-content>
    <mat-divider></mat-divider>
    <div class="row">
      <div class="col-2 pr-0" style="text-align: center; padding-left: 0px !important; padding-top: 15px">
        <!--<em class="material-icons confirm-ico">
          info
        </em>-->
        <em class="fa fa-warning text-primary large"></em>
      </div>
      <div class="col-10 pl-0">
        <div [innerHTML]="data | translate" style="
          padding: 5px 7px 15px;
          font-size: medium;
          overflow-wrap: break-word;
        "></div>
      </div>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions class="justify-content-center mt-2">
    <!--build icon, set default cancel-->
    <button mat-raised-button color="primary" class="ml-2" (click)="close()">
      <mat-icon class="mr-2">cancel</mat-icon>{{ "button.close" | translate }}
    </button>
  </div>